import { LocationStrategy } from "@angular/common";
import { Component, HostListener, Input, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AppLocalStorage } from "app/app-storage-manager/local-storage";
import {
  DAYSOFMONTH,
  DaysOfMonth,
  DAYSOFWEEK,
  Frequency,
  FREQUENCY,
  METHODOFPAYMENT,
  MethodOfPayment,
} from "app/components/giving-sequence/mock.data";
import { PaymentAuthService } from "app/modules/payment/_services/payment-auth.service";
import { SharedDataService } from "app/modules/payment/_services/shared-data.service";
import { MiscService } from "app/shared/misc.service";
import { ToastrService } from "ngx-toastr";

interface CardInfo {
  address: string;
  brand: string;
  cardNumber: string;
  email: string;
  expirationDate: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  _id: string;
}

@Component({
  selector: "app-giving-sequence",
  templateUrl: "./giving-sequence.component.html",
  styleUrls: ["./giving-sequence.component.scss"],
})
export class GivingSequenceComponent implements OnInit {
  @Input() type: string;

  openSummaryModal: boolean = false;
  openSuccessModal: boolean = false;
  displayCarret: boolean = true;
  displaySummary: boolean = true;
  paymentMethodDisplay: boolean = false;
  hideStartDateImg: boolean = false;
  hideEndDateImg: boolean = false;
  isChecked: boolean = false;
  isCheckedSaveCard: boolean = false;
  displayPaymentMethod: boolean;

  productForm: FormGroup;
  cardForm: FormGroup;
  dailyForm: FormGroup;
  weeklyForm: FormGroup;
  monthlyForm: FormGroup;

  cards: string[] = ["Saved Cards", "Enter Card Details"];
  daysOfWeek: string[] = DAYSOFWEEK;

  daysOfMonths: DaysOfMonth[] = DAYSOFMONTH
  methodOfPayments: MethodOfPayment[] = METHODOFPAYMENT;
  frequencies: Frequency[] = FREQUENCY;
  cardInfor: CardInfo[] = [];

  selectedFrequency: Frequency;
  selectedMethodOfPayment: MethodOfPayment;

  selectedCardIndex: number | null = 0;
  total: number = 0;

  nameOfProducts: string;
  merchantId: string = "";

  selectedCard: any = null;
  user: any;
  merchantDetails: any;
  dailyFrequency: any;
  weeklyFrequency: any;
  monthlyFrequency: any;
  selectedDayOfMonth: any;
  endDate: any;
  startDate: any;
  minDate: string = '';

  screenWidth: number = window.innerWidth; // Initialize with the current width
  isMobile: boolean = this.screenWidth <= 768; // Example breakpoint
  wciList: any;
  filteredWciList: any[];
  amountToPayInDaysSelected: number = 0;
  openDesc: boolean = false;
  loginLoading: boolean = false;
  paymentRecords: any;
  instantGiveDetails: any;
  editModeId: any;
  transaction_id: any;
  isEditMode: boolean;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.screenWidth = (event.target as Window).innerWidth;
    this.isMobile = this.screenWidth <= 768; // Adjust based on your breakpoint
  }

  constructor(
    private fb: FormBuilder,
    private route: Router,
    private paymentService: PaymentAuthService,
    private storeManager: AppLocalStorage,
    private toastr: ToastrService,
    public miscService: MiscService,
    private location: LocationStrategy,
    private sharedDataService: SharedDataService,
    private activatedRoute: ActivatedRoute
  ) {
    this.productForm = this.fb.group({
      productFields: this.fb.array([], {
        validators: [this.validateAtLeastOneAmount],
      }),
    });

    this.dailyForm = this.fb.group(
      {
        startDate: ["", Validators.required],
        endDate: ["", Validators.required],
      },
      {
        validators: this.dateOrderValidator,
      }
    );

    this.cardForm = this.fb.group({
      cardHolderName: [
        "",
        [Validators.required, Validators.pattern(/^[a-zA-Z\s]+$/)],
      ],
      cardNumber: [
        "",
        [
          Validators.required,
          Validators.pattern(/^(?:\d{4} ){3}\d{4}$/), // Must be exactly 16 digits with spaces
          this.luhnValidator, // Custom validator for Luhn algorithm
        ],
      ],
      expiryDate: [
        "",
        [
          Validators.required,
          Validators.maxLength(5),
          Validators.pattern(/^(0[1-9]|1[0-2])\/([0-9]{2})$/), // Format: MM/YY with exactly 5 characters
        ],
      ],
      cvv: [
        "",
        [
          Validators.required,
          Validators.pattern(/^\d{3,4}$/), // 3 or 4 digits for CVV
        ],
      ],
      address: ["", [Validators.required]],
      town: ["", [Validators.required]],
      state: ["", [Validators.required]],
      zipCode: ["",[Validators.required]],
      country: ["", [Validators.required]],
    });

    this.weeklyForm = this.fb.group({
      selectedDay: [
        "",
        [
          Validators.required,
          Validators.pattern(
            /^(Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday)$/
          ),
        ],
      ],
    });

    this.monthlyForm = this.fb.group({
      selectedMonth: [
        "",
        [
          Validators.required,
        ],
      ],
    });
  }

  ngOnInit() {
    this.screenWidth = window.innerWidth; // Ensure it's set on initialization
    this.isMobile = this.screenWidth <= 768;
    const today = new Date();
    this.minDate = today.toISOString().split('T')[0];

    this.user = this.storeManager.getFromStorage("logged-in-customer")
      || this.storeManager.getFromSessionStorage('one-time-use')
      || null;
    this.merchantId = this.user.merchant_id;
    this.selectMethodOfPayment(this.methodOfPayments[0]);
    this.selectFrequency(this.frequencies[0]);
    this.getCards();
    this.activatedRoute.params.subscribe((params) => {
      const transactionId = params['id'];
      this.transaction_id = transactionId;
      this.isEditMode = !!transactionId;

      if (transactionId) {
        if (this.type === 'recurring-payment') {
          this.getRecurringPaymentDetails(transactionId);
        } else {
          this.fetchInstantPaymentDetails(transactionId);
        }
      } else {
        this.fetchProducts(this.merchantId);
      }
    });

    this.getMerchant(this.merchantId);
    this.getWciList();
    // this.prefillFormWithData()

  }

  get productFields(): FormArray {
    return this.productForm.get("productFields") as FormArray;
  }

  get selectedDay() {
    return this.weeklyForm.get("selectedDay");
  }

  get selectedMonth() {
    return this.monthlyForm.get("selectedMonth");
  }

  back = () => {
    this.location.back();
  };

  onCloseModal(): void {
    if (this.isEditMode) {
      this.openSummaryModal = false;
    }
    else {
      this.openSummaryModal = false;
      this.isChecked = false;
      this.isCheckedSaveCard = false;
      this.selectedCard = null;
      this.monthlyFrequency = null;
      this.weeklyFrequency = null;
      this.startDate = null;
      this.endDate = null;
      this.dailyForm.reset();
      this.weeklyForm.reset();
      this.monthlyForm.reset();
    }
  }

  onFocus(value: string): void {
    if (value === "startDate") {
      this.hideStartDateImg = !this.hideStartDateImg;
    } else if (value === "endDate") {
      this.hideEndDateImg = !this.hideEndDateImg;
    }
  }

  onBlur(value: string): void {
    if (value === "startDate") {
      this.hideStartDateImg = !this.hideStartDateImg;
    } else if (value === "endDate") {
      this.hideEndDateImg = !this.hideEndDateImg;
    }
  }

  onDateChange() {
    if (this.dailyForm.value.endDate && this.dailyForm.value.startDate) {
      this.calculateTheNumberOfDays(this.dailyForm.value.startDate, this.dailyForm.value.endDate);
    }
  }


  onSubmitDaysOfWeek() {
    if (this.weeklyForm.valid) {
      this.weeklyFrequency = this.weeklyForm.value.selectedDay;
      this.displaySummary = true;
      this.paymentMethodDisplay = false;

    }
  }
  onSubmitMonths() {
    if (this.monthlyForm.valid) {
      this.selectedDayOfMonth = this.monthlyForm.value.selectedMonth;
      this.monthlyFrequency = this.daysOfMonths.find(daysOfMonth => Number(this.selectedDayOfMonth) === daysOfMonth.id);
      this.displaySummary = true;
      this.paymentMethodDisplay = false;
    }
  }
  submitDailyForm(): void {
    if (this.dailyForm.valid) {
      this.startDate = this.dailyForm.value.startDate;
      this.endDate = this.dailyForm.value.endDate;
      this.displaySummary = true;
      this.paymentMethodDisplay = false;
    }

  }

  dateOrderValidator(group: FormGroup) {
    const startDate = group.get("startDate")?.value;
    const endDate = group.get("endDate")?.value;

    if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
      return { dateOrder: true };
    }
    return null;
  }

  selectMethodOfPayment(methodOfPayment: MethodOfPayment): void {
    this.selectedMethodOfPayment = methodOfPayment;
  }

  selectFrequency(frequency: Frequency): void {
    if (this.isEditMode) {
      this.selectedFrequency = frequency;
      if (this.selectedFrequency.id === 'daily') {
        this.weeklyForm.reset({ selectedDay: '' });
        this.monthlyForm.reset({ selectedMonth: '' });
      }
      else if (this.selectedFrequency.id === 'weekly') {
        this.dailyForm.reset();
        this.monthlyForm.reset({ selectedMonth: '' });
      }
      else if (this.selectedFrequency.id === 'monthly') {
        this.dailyForm.reset();
        this.weeklyForm.reset({ selectedDay: '' });
      }
    }
    else {
      this.monthlyForm.reset({ selectedMonth: '' });
      this.weeklyForm.reset({ selectedDay: '' });
      this.dailyForm.reset();
      this.selectedFrequency = frequency;
    }
  }

  selectCard(index: number): void {
    this.selectedCardIndex = this.selectedCardIndex === index ? null : index;
    this.cardForm.reset({
      cardHolderName: '',
      cardNumber: '',
      expiryDate: '',
      cvv: '',
      address: '',
      town: '',
      state: '',
      zipCode: '',
      country: ''
    });
    this.getCards()
  }

  backToInstantGiveSummary(): void {
    if (this.isEditMode && this.type === 'recurring-payment') {
      this.selectedFrequency = this.frequencies.find(frequency => frequency.id === this.paymentRecords.frequency.type.toLowerCase());

      if (this.selectedFrequency.id === 'daily') {
        this.dailyForm.patchValue({
          startDate: this.startDate,
          endDate: this.endDate
        });
      }
      if (this.selectedFrequency.id === 'weekly') {
        this.weeklyForm.patchValue({
          selectedDay: this.weeklyFrequency
        });
      }
      if (this.selectedFrequency.id === 'monthly') {
        this.monthlyForm.patchValue({
          selectedMonth: this.monthlyFrequency
        });
      }
      // this.displaySummary = true;
      this.calculateTheNumberOfDays(this.startDate, this.endDate);
    }
    this.displaySummary = true;
  }

  isBtnDisabled(): boolean {
    if (this.type === 'recurring-payment') {
      // Button is disabled if either selectedFrequency or selectedCard is undefined
      return (this.monthlyForm.invalid && this.selectedFrequency.id === 'monthly') ||
        (this.weeklyForm.invalid && this.selectedFrequency.id === 'weekly') ||
        (this.dailyForm.invalid && this.selectedFrequency.id === 'daily') ||
        !this.selectedCard;
    } else {
      // Button is disabled if selectedCard is undefined
      return !this.selectedCard;
    }
  }


  initializeForm(products: any[]): void {
    products.forEach((product) => {
      const group = this.fb.group({
        productName: [product.name], // Readonly, not used in the form directly
        description: [{ value: product.description || "", disabled: product.amount ? false : true }],
        amount: [product.amount || ""],
        product_id: [product.product_id],
        isDescOpen: [false]
      });



      group.get("amount")?.valueChanges.subscribe((value) => {
        const descriptionControl = group.get("description");
        const sanitizedValue = parseFloat((value || "").replace(/,/g, ""));

        if (sanitizedValue > 0) {
          descriptionControl?.enable({ emitEvent: false });
        } else {
          descriptionControl?.disable({ emitEvent: false });
        }
      });

      this.productFields.push(group);
    });
  }

  onAmountInput(index: number, event: any): void {
    const input = event.target.value;

    // Format the value
    const formattedValue = this.formatAmount(input);

    // Update the form control
    this.productFields.at(index).get("amount")?.setValue(formattedValue, {
      emitEvent: false, // Prevent triggering additional changes
    });

    // Trigger validation
    this.productForm.updateValueAndValidity();
  }

  onAmountBlur(index: number): void {
    const control = this.productFields.at(index).get('amount');
    const value = control?.value || '';

    // Remove formatting commas and convert to number
    const sanitizedValue = parseFloat(value.replace(/,/g, ''));

    if (!isNaN(sanitizedValue)) {
      // Format to two decimal places
      const formattedValue = sanitizedValue.toFixed(2);

      // Update the form control value with the formatted amount
      control?.setValue(formattedValue, { emitEvent: false });
    }
  }

  formatAmount(value: string): string {
    // Remove non-numeric characters except "."
    const sanitized = value.replace(/[^0-9.]/g, "");

    // Format as number with commas
    const parts = sanitized.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  onAmountChange(): void {
    // Calculate total amount
    this.total = this.productFields.controls.reduce((sum, group) => {
      return sum + Number(group.get("amount")?.value.replace(/,/g, "") || 0);
    }, 0);
    this.amountToPayInDaysSelected = this.total;
  }

  validateAtLeastOneAmount(
    formArray: FormArray
  ): { [key: string]: boolean } | null {
    // Check if at least one amount is valid
    const hasValidAmount = formArray.controls.some((control) => {
      const amount = control.get("amount")?.value || "";
      const sanitizedAmount = parseFloat(amount.replace(/,/g, ""));
      return !isNaN(sanitizedAmount) && sanitizedAmount > 0;
    });
    return hasValidAmount ? null : { noValidAmount: true };
  }

  listValidProductNames(): string {
    const productFields = this.productFields.controls; // Get form array controls

    // Filter valid products with a valid amount
    const validProducts = productFields
      .filter((field) => {
        const amount = field.get("amount")?.value.toString() || "";
        // Check if the amount is a valid number and greater than 0
        return (
          !isNaN(parseFloat(amount.replace(/,/g, ""))) &&
          parseFloat(amount.replace(/,/g, "")) > 0
        );
      })
      .map((field) => field.get("productName")?.value); // Extract product names

    // Format the product names with commas and "and"
    if (validProducts.length === 0) return ""; // No valid products

    if (validProducts.length === 1) {
      return validProducts[0]; // Single product
    }

    // Join names with commas, and add "and" before the last name
    return (
      validProducts.slice(0, -1).join(", ") +
      " and " +
      validProducts[validProducts.length - 1]
    );
  }

  getSelectedProductNames() {
    const products = this.productForm.value.productFields
      .map((product: any) => ({
        name: product.productName,
        product_id: product.product_id,
        amount: Number(product.amount),
        description: product.description || "",
      }))
      .filter((product: any) => product.amount > 0);

    return products;
  }

  editModeOps() {
    this.prepareInstantGive();
  }

  onSaveInstantGive(): void {
    if (!this.selectedCard) {
      this.prepareInstantGive();
    }
    else {
      this.makeIntantGive()
    }
  }

  makeIntantGive(): void {
    const payload = this.createInstantGivePayload()
    if (this.isEditMode) {
      this.paymentService.updateInstantGive(this.paymentRecords._id, payload).subscribe(
        (response: any) => {
          if (response) {
            this.openSummaryModal = false;
            this.openSuccessModal = true;
          }
        },
        (err) => {
          this.toastr.error(err.error.message, "Error");
        }
      );
    }
    else {
      this.callInstatGiveApi(payload)
    }
  }


  private prepareInstantGive(): void {
    this.nameOfProducts = this.listValidProductNames();
    this.onAmountChange();
    this.openSummaryModal = true;
  }

  private createInstantGivePayload(): any {
    return {
      merchant_id: this.merchantId,
      country_code: this.merchantDetails.currency,
      products: this.getSelectedProductNames(),
      customer_id: this.user._id,
      total_amount: Number(this.total),
      payment_method: this.selectedMethodOfPayment.type,
      gift_aid: this.isChecked,
      payment_method_id: this.selectedCard._id,
    };
  }

  callInstatGiveApi = (payload) => {
    this.paymentService.instantGive(payload).subscribe(
      (response: any) => {
        if (response.success) {
          this.openSummaryModal = false;
          this.openSuccessModal = true;
        }
      },
      (err) => {
        this.toastr.error(err.error.message, "Error");
      }
    );
  }



  calculateTheNumberOfDays = (startDate: string, endDate: string) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diff = Math.abs(end.getTime() - start.getTime());
    const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
    this.amountToPayInDaysSelected = days !== 0 ? days * Number(this.total) : Number(this.total);
  }

  onSaveRecurringPayment(): void {
    const frequency = {
      type: this.selectedFrequency.title,
      start_date: this.dailyForm.value.startDate,
      end_date: this.dailyForm.value.endDate,
      day_of_month: Number(this.monthlyForm.value.selectedMonth) || null,
      day_of_week: this.weeklyForm.value.selectedDay || null,
    }
    const payload = {
      merchant_id: this.merchantId,
      country_code: this.merchantDetails.currency,
      products: this.getSelectedProductNames(),
      customer_id: this.user._id,
      total_amount: Number(this.total),
      frequency: frequency,
      payment_method: this.selectedMethodOfPayment.type,
      gift_aid: this.isChecked,
      payment_method_id: this.selectedCard._id,
    };

    if (this.isEditMode) {
      this.paymentService.updateRecurringPayment(this.paymentRecords._id, payload).subscribe(
        (response: any) => {
          if (response) {
            this.openSummaryModal = false;
            this.openSuccessModal = true;
          }
        },
        (err) => {
          this.toastr.error(err.error.message, "Error");
        }
      );
    }
    else {
      this.paymentService.recurringPayment(payload).subscribe(
        (response: any) => {
          if (response.success) {
            this.openSummaryModal = false;
            this.openSuccessModal = true;
          }
        },
        (err) => {
          this.toastr.error(err.error.message, "Error");
        }
      );
    }


  }

  onCompleteInstantGiveProcess(): void {
    this.openSuccessModal = false;
    if (this.type === 'recurring-payment') {
      this.route.navigate(["/payments/recurring-payment"]);
    }
    else {
      if (this.isEditMode) {
        this.route.navigate(["/payments/instant-give-list"]);
      }
      else {
        this.route.navigate(["/payments/wcis"]);
      }
    }
  }

  onPaymentMethod(): void {
    this.displaySummary = false;
    this.paymentMethodDisplay = true;
  }

  onSaveSelectedCard(): void {
    // Save the selected card and send the payment
    if (this.selectedCard) {
      this.displaySummary = true;
    }
  }

  onSelectCardClick(card: any): void {
    this.selectedCard = card;
  }

  // Custom Method to Validate Expiry Date
  isCardExpired(): boolean {
    const expiryDate = this.cardForm.get("expiryDate")?.value;
    if (!expiryDate) return false;

    const [month, year] = expiryDate.split("/");
    const expiry = new Date(
      parseInt(`20${year.length === 2 ? year : year.slice(-2)}`),
      parseInt(month) - 1
    );
    return expiry < new Date();
  }

  saveNewCard() {
    const payload = {
      card_number: this.cardForm.get("cardNumber")?.value.replace(/\s+/g, ''),
      expiry_date: this.cardForm.get("expiryDate")?.value,
      cvv: this.cardForm.get("cvv")?.value,
      address: this.cardForm.get("address")?.value,
      town: this.cardForm.get("town")?.value,
      state: this.cardForm.get("state")?.value,
      zipCode: this.cardForm.get("zipCode")?.value,
      country: this.cardForm.get("country")?.value,
      email: this.user.email,
    };
    this.loginLoading = true
    this.paymentService.addCard(payload).subscribe(
      (response: any) => {
        if (response.status) {
          this.loginLoading = false
          this.cardForm.reset();
          this.isCheckedSaveCard = false;
          this.selectedCardIndex = 0; // Set the active tab to the saved card
          this.toastr.success("Card saved successfully", "Success");
          this.getCards();
        }
      },
      (err) => {
        this.loginLoading = false
        this.toastr.error(err.error.message, "Error");
      }
    );
  }

  getCards() {
    this.paymentService.getCards(this.user.email).subscribe(
      (response: any) => {
        if (response.status) {
          this.cardInfor = response.data;
          this.selectedCard = this.cardInfor.find(card => card._id === this.paymentRecords.payment_method_id);
        }
      },
    );
  }

  luhnValidator(control: any): { [key: string]: boolean } | null {
    const value = control.value.replace(/\s+/g, ''); // Remove spaces
    if (!value) return null;

    let sum = 0;
    let shouldDouble = false;

    // Process digits from right to left
    for (let i = value.length - 1; i >= 0; i--) {
      let digit = parseInt(value.charAt(i), 10);

      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }

      sum += digit;
      shouldDouble = !shouldDouble;
    }

    // If sum is divisible by 10, the card number is valid
    return sum % 10 === 0 ? null : { invalidCard: true };
  }

  preventLetter(evt: any): boolean {
    var charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
    return true;
  }

  fetchProducts = (merchantId) => {
    this.paymentService.fetchMerchantproducts(merchantId).subscribe(
      (res: any) => {
        if (res.success) {
          this.productFields.clear();
          this.initializeForm(res.data.products.reverse());
        }
      },
      (err) => {
        this.toastr.error(err.error.message, "Error");
      }
    );
  };

  getRecurringPaymentDetails = (transactionId) => {
    this.paymentService.fetchRecurringPaymentDetails(transactionId).subscribe(
      (res: any) => {
        if (res) {
          this.paymentRecords = res.data;

          this.initFormHelperFunc(this.paymentRecords);
          this.selectedFrequency = this.frequencies.find(frequency => frequency.id === this.paymentRecords.frequency.type.toLowerCase());

          this.startDate = this.removeTimeFromDate(this.paymentRecords.frequency.start_date);
          this.endDate = this.removeTimeFromDate(this.paymentRecords.frequency.end_date);
          this.calculateTheNumberOfDays(this.startDate, this.endDate);
          this.weeklyFrequency = this.paymentRecords.frequency.day_of_week;
          this.monthlyFrequency = this.paymentRecords.frequency.day_of_month;
          this.isChecked = this.paymentRecords.gift_aid;

          this.dailyForm.patchValue({
            startDate: this.paymentRecords.frequency.start_date,
            endDate: this.paymentRecords.frequency.end_date
          });

          this.weeklyForm.patchValue({
            selectedDay: this.weeklyFrequency
          });

          this.monthlyForm.patchValue({
            selectedMonth: this.monthlyFrequency
          });

          this.selectFrequency(this.selectedFrequency);


        }
      },
      (err) => {
        this.toastr.error(err.error.message, "Error");
      }
    );
  }

  fetchInstantPaymentDetails = (transactionId) => {
    // this.loading = true;
    this.paymentService.fetchInstantPaymentDetails(transactionId).subscribe(
      (res: any) => {
        if (res.status) {
          // this.loading = false;
          this.paymentRecords = res.data;
          this.initFormHelperFunc(this.paymentRecords);
          this.isChecked = this.paymentRecords.gift_aid;

        } else {
          // this.loading = false;
          this.paymentRecords = null;
        }
      },
      (err) => {
        // this.loading = false;
        this.toastr.error(err.error.message, "Error");
      }
    );
  };

  removeTimeFromDate(dateString: string): string {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  initFormHelperFunc(data) {
    data.products.forEach((product: any) => {
      product.amount = product.amount.toFixed(2).toString();
    });
    return this.initializeForm(data.products.reverse());
  }

  getMerchant = (merchantId) => {
    this.paymentService.fetchMerchantDetails(merchantId).subscribe(
      (res: any) => {
        if (res) {
          this.merchantDetails = res;
        }
      },
      (err) => {
        this.toastr.error(err.error.message, "Error");
      }
    );
  };

  onFrequency() {
    this.displaySummary = false;
    this.paymentMethodDisplay = false;
    if (this.isEditMode) {
      this.selectFrequency(this.selectedFrequency);
      if (this.selectedFrequency.id === 'daily') {
        this.dailyForm.patchValue({
          startDate: this.startDate,
          endDate: this.endDate
        });
      }
      if (this.selectedFrequency.id === 'weekly') {
        this.weeklyForm.patchValue({
          selectedDay: this.weeklyFrequency
        });

      } if (this.selectedFrequency.id === 'monthly') {
        this.monthlyForm.patchValue({
          selectedMonth: this.monthlyFrequency
        });
      }
    }

  }

  getWciList(): void {
    // this.loading = true;
    this.paymentService.fetchWciMerchants().subscribe((response: any) => {
      if (response.success) {
        this.wciList = response?.data || [];
        // this.loading = false;
      } else {
        // this.loading = false;
      }
    }, err => {
      // this.loading = false;
      this.toastr.error(err.error.message, 'Error');
    });
  }

  goToHome() {
    this.route.navigate(["/payments/wcis"]);
  }

  openDescription(id: number) {
    this.productFields.controls.forEach((control, index) => {
      if (index === id) {
        control.get('isDescOpen')?.setValue(
          !control.get('isDescOpen')?.value
        );
      }
    })
  }

  formatExpiryDate(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, ''); // Remove non-numeric characters

    if (value.length >= 3) {
      // Insert slash after the first two characters
      value = value.substring(0, 2) + '/' + value.substring(2, 4);
    }

    input.value = value;
    this.cardForm.get('expiryDate')?.setValue(value, { emitEvent: false });
  }

  formatCardNumber(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, ''); // Remove all non-digit characters

    // Add a space every 4 digits
    value = value.replace(/(.{4})/g, '$1 ').trim();

    input.value = value; // Update the input value
    this.cardForm.get('cardNumber')?.setValue(value, { emitEvent: false }); // Update the form control
  }

}
